import { differenceInSeconds, isFuture, subSeconds } from 'date-fns';
import { isServer } from '../config';
import { getCookie } from '../cookies';
import { getAccessTokenExpiration } from './getAccessTokenExpiration';

/**
 * This method for getting the expiration Date of the access token
 *
 * @returns true if the access token has expired
 */
export const hasAccessTokenExpired = (
  accessToken?: string | null,
  bufferSeconds = 0
): boolean => {
  try {
    if (!accessToken) {
      throw new Error('No access token');
    }
    // Buffer to avoid race conditions where the token is valid now but not on client in a few seconds
    const expiresAt = getAccessTokenExpiration(accessToken);
    const safeExpiresAt = subSeconds(expiresAt, bufferSeconds);
    const expiresInSeconds = differenceInSeconds(expiresAt, new Date());

    // When the access token expiration is overridden, log time remaining
    if (!isServer && getCookie('ff-auth-token-max-seconds')) {
      // eslint-disable-next-line no-console
      console.log({
        authTokenExpiresIn: `${expiresInSeconds} seconds`,
      });
    }

    // access token has not expired
    if (isFuture(safeExpiresAt)) {
      return false;
    }

    return true;
  } catch {
    return true;
  }
};
